<template>
  <div class="video-rank-select-page">

    <a-button @click="show = true" type="dashed" :icon="'upload'">
      <template v-if="localIds.length > 0"> 已选择{{ localIds.length }}/{{ maxNum }}个视频</template>
      <template v-else>点击添加视频</template>
      <!-- <template>点击添加视频</template> -->
    </a-button>

    <a-tag @click="clearSelected" color="orange" v-if="localIds.length > 0" style="margin-left:20px;cursor:pointer">
      点击清空所有视频
    </a-tag>
    
    <a-modal
      title="素材排行"
      centered
      :width="1300"
      :mask-closable="false"
      :visible="show"
      :confirmLoading="false"
      :bodyStyle="{ paddingBottom: '10px' }"
      @ok="close"
      @cancel="close"
    >

      <div class="search-wrapper" >
          <div class="title" style="height:10px;line-height:10px"><a-icon type="search" /> 数据筛选</div>
          <a-space style="margin-top:15px">

            <a-select show-search placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children" @change="changeCorporation">
              <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                {{ corporation.name }}
              </a-select-option>
            </a-select>
            
            <a-select allow-clear placeholder="媒体" v-model="queryParam.media" show-search option-filter-prop="children">
                <a-select-option :value="media.id" v-for="media in medias" :key="media.id" >
                    {{ media.name }}
                </a-select-option>
            </a-select>

            <a-select allow-clear placeholder="应用类型" v-model="queryParam.app_type" show-search option-filter-prop="children">
                <a-select-option :value="item.id" v-for="item in appTypes" :key="item.id" >
                    {{ item.name }}
                </a-select-option>
            </a-select>
            <a-select allow-clear placeholder="付费类型" v-model="queryParam.pay_type" show-search option-filter-prop="children" @change="changePayType">
                <a-select-option :value="item.id" v-for="item in payTypes" :key="item.id" >
                    {{ item.name }}
                </a-select-option>
            </a-select>


            <a-select allow-clear placeholder="优化师" v-model="queryParam.worker_id" show-search option-filter-prop="children">
                <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id" >
                    {{ worker.name }}
                </a-select-option>
            </a-select>

            <a-popover title="广告主ID">
                <template slot="content">
                    <a-textarea
                    v-model="advertiser_ids"
                    placeholder="请输入广告主ID"
                    :auto-size="{ minRows: 5, maxRows: 8 }"
                  />
                </template>
                <a-input placeholder="广告主ID" v-model="queryParam.advertiser_id" />
            </a-popover>

            <a-popover title="素材ID">
              <template slot="content">
                  <a-textarea
                  v-model="material_ids"
                  placeholder="请输入素材ID"
                  :auto-size="{ minRows: 5, maxRows: 8 }"
                />
              </template>
              <a-input placeholder="素材ID" v-model="queryParam.material_id" />
            </a-popover>

            <a-input placeholder="素材名称" v-model="queryParam.material_name" />

            <a-auto-complete
              placeholder="媒体主体"
              :data-source="filteredCorporations"
              v-model="queryParam.advertiser_name"
              @change="changeMediaCorporation"
              allowClear
            />

            <a-input placeholder="短剧名称" v-model="queryParam.video_name" />

            <a-select allow-clear placeholder="有效消耗" v-model="queryParam.is_effective_cost" show-search option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in [{id:1,name:'是'}, {id:2,name:'否'}]" :key="item.id" >
                  {{ item.name }}
              </a-select-option>
            </a-select>
              
            <date-select v-model="queryParam.date"/>

            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="resetSearch">重置</a-button>

          </a-space>
      </div>

      <vxe-grid
        ref="xGrid"
        class="table-scrollbar"
        v-bind="tableGrid"
        :height="530"
        row-id="material_id"
        @page-change="handlePageChange"
        @sort-change="handleSortChange"
        @checkbox-change="handleRowChange"
        @checkbox-all="handleCheckboxAll"
        :checkbox-config="{ checkRowKeys: selectedRowKeys, checkMethod: checCheckboxkMethod, reserve: true}"
      >

        <template #toolbar_buttons>
          <a-tag color="cyan" > 总消耗： {{ sum_cost }} </a-tag>
          <a-tag color="cyan" > 真实roi： {{ real_roi }}% </a-tag>
        </template>

        <template #video_cover="{ row }" >
          <div class="cover" @click="showPreview(row)">
            <div>
              <img :src="row.new_video_cover|defaultCover" alt=""  >
              <a-icon type="play-circle" class="play-icon" />
            </div>
          </div>

          <template v-if="!row.local_material">
            <a-tag color="orange" style="margin-top:5px" v-if="!row.local_material">上传人： 待上传 </a-tag>
          </template>
          <template v-else>
            <a-tag color="blue" style="margin-top:5px" >上传人： {{ row.local_material && row.local_material.worker_name || '待上传' }} </a-tag>
          </template>
          <div> {{ row.create_time }} </div>
        </template>

        <template #material="{ row }">
          <div>
            {{ row.name || '-' }}<br>
            【{{ row.material_id || '-' }}】<br>
          </div>
        </template>

        <template #advertiser="{ row }">
          {{row.advertiser_name}} <br>
          【{{row.advertiser_id}}】
        </template>

        <template #is_illegal="{ row }">
          <template v-if="accessTo('updateMaterialField')">
            <a-button type="danger" size="small" v-if="row.is_illegal == true" @click="updateMaterialField(row.material_id, false, 'is_illegal', true)">违规</a-button>
            <a-button type="primary" size="small" v-else  @click="updateMaterialField(row.material_id, true, 'is_illegal', true)">正常</a-button>
          </template>
          <template v-else>
            <a-button type="danger" size="small" v-if="row.is_illegal == true">违规</a-button>
            <a-button type="primary" size="small" v-else>正常</a-button>
          </template>
        </template>

        <!-- <template #action="{ row }">
          <div style="height:199px;line-height:199px">
            <a href="#" @click="showPromotions(row)" v-if="row.media == 2">广告详细</a>
            <span v-if="row.media == 2 && accessTo('LocalMaterialController@uploadToMedia')">
              <a-divider type="vertical"/>
              <a href="#"  @click="uploadToMedia(row)">素材推送</a>
            </span>
          </div>
        </template> -->
      </vxe-grid>

      <a-modal :visible="preview.url?true:false" :footer="null" @cancel="leavePreview">
        <video v-if="preview.url" autoplay controls style="width: 91%" :src="preview.url" />
      </a-modal>

    </a-modal>
  </div>
</template>

<style lang="less" scoped>
@import 'VideoRankSelect';
</style>

<script>
import VideoRankSelect from './VideoRankSelect'
export default VideoRankSelect
</script>
